export default __webpack_public_path__ + "static/cloudDevOps-f53ef8dd6d7648cf207f3dd0461c4fcb.svg";